module.exports = __webpack_public_path__ + "img/electronic-agreement-pic.a8fc5a36.png";